<template>
  <Modal
    v-model="shows"
    :title="$t('edit.index.885685-0')"
    ref="modal"
    draggable
    class-name="vertical-center-modal"
    :ok-text="$t('edit.index.885685-1')"
    width="730"
    height="600"
    :loading="loading"
    @on-ok="submit"
    @on-cancel="shows = false"
  >
    <Form
      ref="details"
      :model="fromData"
      :rules="ruleValidate"
      label-position="right"
      :label-width="120"
    >
      <Row span="24">
        <Col span="10">
          <FormItem :label="$t('edit.index.885685-2')" prop="DeviceCode">
            <Input
              v-model="fromData.DeviceCode"
              :placeholder="$t('edit.index.885685-3')"
              disabled
            ></Input>
          </FormItem>
        </Col>
        <Col span="10">
          <FormItem :label="$t('edit.index.885685-4')" prop="UserDeviceName">
            <Input
              v-model="fromData.UserDeviceName"
              :placeholder="$t('edit.index.885685-5')"
            ></Input>
          </FormItem>
        </Col>
        <Col span="10">
          <FormItem :label="$t('edit.index.885685-6')" prop="ContactsName">
            <Input
              v-model="fromData.ContactsName"
              :placeholder="$t('edit.index.885685-7')"
            ></Input>
          </FormItem>
        </Col>
        <Col span="10">
          <FormItem :label="$t('edit.index.885685-8')" prop="ContactsPhone">
            <Input
              v-model="fromData.ContactsPhone"
              :placeholder="$t('edit.index.885685-9')"
            ></Input>
          </FormItem>
        </Col>
      </Row>
    </Form>
  </Modal>
</template>

<script>
import api from "../../../../../../api/request.js";
import Cookies from "js-cookie";

const URL = {
  UpdateUserDevice: "api/YhjDevice/UpdateUserDevice"
};

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    },
    data: {
      type: Object
    }
  },
  data() {
    return {
      loading: true,
      fromData: {},
      ruleValidate: {
        UserDeviceName: [
          { required: true, message: this.$t('edit.index.885685-10'), trigger: "change" }
        ]
      }
    };
  },
  watch: {
    show(value) {
      if (value) {
        this.fromData = { ...this.data };
      }
    }
  },
  mounted() {},
  computed: {
    shows: {
      get() {
        return this.show;
      },
      set(newValue) {
        this.$emit("update:show", newValue);
      }
    }
  },
  methods: {
    submit() {
      this.$refs.details.validate(valid => {
        if (valid) {
          this.UpdateUserDevice();
        } else {
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    UpdateUserDevice() {
      api(
        {
          //这里是你自己的请求方式、url和data参数
          method: "post",
          url: URL.UpdateUserDevice,
          data: { ...this.fromData, UserId: this.fromData.User_Id },
          //假设后台需要的是表单数据这里你就可以更改
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            Authorization: Cookies.get("Token")
          }
        },
        "yhj"
      ).then(res => {
        this.shows = false;
        if (res.Success) {
          this.$Message["success"]({
            background: true,
            content: res.Message
          });
            this.$emit('on-edit')
        } else {
          this.$Message["error"]({
            background: true,
            content: res.Message
          });
        }
      });
    }
  }
};
</script>

<style scoped="scoped">
.area-text {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/useGas/views/device/mods/edit/index.vue